(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["preloader"] && !Shopify.designMode) return;
  try {
    const preloader = document.getElementById('preloader-overlay');
  // const bee = preloader?.querySelector('.preloader__bee');

  if (!preloader) return;

  // Play bee animation once on load
  // if (bee) {
  //   bee.addEventListener('load', () => {
  //     const player = bee.dotLottie;
  //     if (player) {
  //       player.setLoop(false);
  //       player.play();
  //     }
  //   });
  // }

  // on page loaded, fade out preloader after 2 sec delay
  window.addEventListener('load', () => {
    setTimeout(() => {
      preloader.classList.add('preloader--fade-out');

      preloader.addEventListener(
        'animationend',
        () => {
          // 1. Find the players
          const players = preloader.querySelectorAll('dotlottie-wc');

          // 2. Explicitly stop and nullify them before removal
          players.forEach((player) => {
            if (player.dotLottie) {
              player.dotLottie.pause();
              player.dotLottie.destroy(); // This is the most important call for Firefox
            }
            player.src = ''; // Clear the source to break the load loop
          });

          // 3. Now it is safe to remove from DOM
          preloader.remove();
        },
        { once: true }
      ); // Ensure this only runs once
    }, 2000);
  });
  } catch(e) { console.error(e); }
})();

})();
